export const PCON_LOGIN_CLIENT_ID: string = 'EGR-IPI';
export const PCON_LOGIN_HOST: string = 'login.pcon-solutions.com';
export const PCON_LOGIN_PROFILE_URL: string = 'https://' + PCON_LOGIN_HOST + '/';
export const PCON_LOGIN_AUTH_URL: string = 'https://' + PCON_LOGIN_HOST + '/api/oauth2/authorize';
export const PCON_LOGIN_USER_API: string = 'https://' + PCON_LOGIN_HOST + '/api/v1/account/user';
export const PCON_LOGIN_ORGANIZATION_API: string = 'https://' + PCON_LOGIN_HOST + '/api/v1/account/organization';
export const PCON_LOGIN_LOGOUT_API: string = 'https://' + PCON_LOGIN_HOST + '/api/v1/logout';

export const PCON_UPDATE_API_URL: string = 'https://update.easterngraphics.com/api/v1/';
export const PCON_UPDATE_PACKAGE_URL: string = PCON_UPDATE_API_URL + 'get_package_groups';

export const EAIWS_FALLBACK_LANGUAGES: Array<string> = ['en', 'de', 'fr', 'nl'];
// tslint:disable-next-line:max-line-length
export const ITUNES_LINK: string = 'https://itunes.apple.com/' + (navigator.language || (navigator as any).userLanguage).substr(0, 2) + '/app/pcon.box/id1124979472?mt=8';
export const GOOGLE_LINK: string = 'https://play.google.com/store/apps/details?id=com.easterngraphics.ipi';
export const MICROSOFT_LINK: string = 'https://www.microsoft.com/store/apps/9nblggh536ct';

export const IMAGESEARCH_API_URL: string = 'https://web02.cadse.egr.eu:443/cadse_service/get_ofml_images/default';


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/Api.ts